import ReminderSelection from './ReminderSelection';
import EventDurationSelection from './EventDurationSelection';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
/**
 * Stateless functional component to render event duration and reminder dropdowns.
 */
export default observer(function EventFull() {
    return (React.createElement("div", null,
        React.createElement(OptionDescription, null, strings.options_event_description),
        isControlFeatureEnabled('cal-event-duration-setting') && React.createElement(EventDurationSelection, null),
        React.createElement(ReminderSelection, null)));
});
//# sourceMappingURL=EventFull.js.map